"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _draftJs = require("draft-js");

var _default = function _default() {
  for (var _len = arguments.length, entityTypes = new Array(_len), _key = 0; _key < _len; _key++) {
    entityTypes[_key] = arguments[_key];
  }

  return function (WrappingComponent) {
    if (WrappingComponent.prototype && WrappingComponent.prototype.isReactComponent) {
      return (0, _createReactClass.default)({
        displayName: "MutableEntityWithBoundaries(" + WrappingComponent.displayName + ")",
        propTypes: {
          editorState: _propTypes.default.instanceOf(_draftJs.EditorState),
          handleBeforeInput: _propTypes.default.func,
          onChange: _propTypes.default.func.isRequired
        },
        shouldPreserveLinkEntityBoundary: function shouldPreserveLinkEntityBoundary(editorState) {
          var selection = editorState.getSelection();
          var contentState = editorState.getCurrentContent();
          var blockKey = selection.getStartKey();
          var nextCharacterIndex = selection.getStartOffset();
          var previousCharacterIndex = nextCharacterIndex - 1;

          if (previousCharacterIndex < 0) {
            return false;
          }

          var block = contentState.getBlockForKey(blockKey);
          var previousCharacterEntity = block.getEntityAt(previousCharacterIndex);
          var nextCharacterEntity = block.getEntityAt(nextCharacterIndex);
          return previousCharacterEntity !== null && nextCharacterEntity === null && entityTypes.includes(contentState.getEntity(previousCharacterEntity).getType());
        },
        handleBeforeInput: function handleBeforeInput(chars) {
          var _this$props = this.props,
              editorState = _this$props.editorState,
              handleBeforeInput = _this$props.handleBeforeInput,
              onChange = _this$props.onChange;

          if (!this.shouldPreserveLinkEntityBoundary(editorState)) {
            return handleBeforeInput && handleBeforeInput(chars);
          }

          var updatedContentState = _draftJs.Modifier.insertText(editorState.getCurrentContent(), editorState.getSelection(), chars, editorState.getCurrentInlineStyle(), null);

          onChange(_draftJs.EditorState.push(editorState, updatedContentState, 'insert-characters'));
          return true;
        },
        focus: function focus() {
          if (this.refs.child.focus) {
            this.refs.child.focus();
          }
        },
        blur: function blur() {
          if (this.refs.child.blur) {
            this.refs.child.blur();
          }
        },
        render: function render() {
          return _react.default.createElement(WrappingComponent, Object.assign({}, this.props, {
            ref: "child",
            handleBeforeInput: this.handleBeforeInput
          }));
        }
      });
    }

    return WrappingComponent;
  };
};

exports.default = _default;
module.exports = exports.default;